<div class="contract-editor">
  @if (!payload && loading) {
    <!-- CLAUDE.md Regel 19, Stufe B: der Reiter laedt als Ganzes. -->
    <app-orbi-loader [size]="96" [label]="'dialogs.contract.loading' | translate"></app-orbi-loader>
  } @else if (!payload && loadError) {
    <div>
      <p class="state">{{ "dialogs.contract.loadError" | translate }}</p>
      <button nbButton status="basic" size="small" type="button" (click)="load()">
        {{ "dialogs.contract.retry" | translate }}
      </button>
    </div>
  } @else if (payload) {
    <div [formGroup]="form">
      <!-- Status + Laufzeit -->
      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.contract.sections.status" | translate }}</h5>
        </header>

        @if (contract) {
          <p class="state state--active">
            <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
            <span>
              {{
                "dialogs.contract.activeSince"
                  | translate
                    : {
                        date: (contract.starts_on | date: "dd.MM.yyyy"),
                        plan: currentPlanLabel
                      }
              }}
            </span>
          </p>
        } @else {
          <p class="state">
            {{ "dialogs.contract.noContract" | translate: { plan: currentPlanLabel } }}
          </p>
        }

        @if (payload.has_stripe_subscription) {
          <p class="notice">
            <nb-icon icon="alert-circle-outline"></nb-icon>
            <span>{{ "dialogs.contract.stripeHint" | translate }}</span>
          </p>
        }

        <div class="grid">
          <label class="label" for="contract-source">{{ "dialogs.contract.fields.source" | translate }}</label>
          <div class="field">
            <nb-select
              id="contract-source"
              fullWidth
              formControlName="source"
              (selectedChange)="onSourceChange($event)"
            >
              <nb-option [value]="sourceCurrent">{{
                (contract ? "dialogs.contract.source.contract" : "dialogs.contract.source.current") | translate
              }}</nb-option>
              <nb-option [value]="sourceEmpty">{{ "dialogs.contract.source.empty" | translate }}</nb-option>
              @if (contractTemplates.length) {
                <nb-option-group [title]="'dialogs.contract.source.templates' | translate">
                  @for (tpl of contractTemplates; track tpl.id) {
                    <nb-option [value]="templateSource(tpl)">{{ tpl.name }}</nb-option>
                  }
                </nb-option-group>
              }
              <nb-option-group [title]="'dialogs.contract.source.plans' | translate">
                @for (plan of templates; track plan.id) {
                  <nb-option [value]="planSource(plan)">{{ plan.display_name || plan.name }}</nb-option>
                }
              </nb-option-group>
            </nb-select>
            <p class="hint">{{ "dialogs.contract.hints.source" | translate }}</p>
            <div class="template-actions">
              <button
                nbButton
                status="basic"
                size="small"
                type="button"
                [disabled]="templateBusy"
                [nbSpinner]="templateBusy"
                (click)="saveAsTemplate()"
              >
                <nb-icon icon="save-outline"></nb-icon>
                {{ "dialogs.contract.templates.save" | translate }}
              </button>
              @if (selectedTemplate) {
                <button
                  nbButton
                  status="basic"
                  size="small"
                  type="button"
                  [disabled]="templateBusy"
                  (click)="saveAsTemplate(true)"
                >
                  <nb-icon icon="edit-2-outline"></nb-icon>
                  {{ "dialogs.contract.templates.update" | translate }}
                </button>
                <button
                  nbButton
                  status="basic"
                  size="small"
                  type="button"
                  [disabled]="templateBusy"
                  (click)="deleteTemplate()"
                >
                  <nb-icon icon="trash-2-outline"></nb-icon>
                  {{ "dialogs.contract.templates.delete" | translate }}
                </button>
              }
            </div>
          </div>

          <label class="label" for="contract-display-name">{{ "dialogs.contract.fields.display_name" | translate }}</label>
          <div class="field">
            <input
              id="contract-display-name"
              nbInput
              fullWidth
              formControlName="display_name"
              [status]="showInputError('display_name') ? 'danger' : 'basic'"
            />
            <p class="hint">{{ "dialogs.contract.hints.display_name" | translate }}</p>
          </div>

          <label class="label" for="contract-starts-on">{{ "dialogs.contract.fields.starts_on" | translate }}</label>
          <div class="field">
            <input
              id="contract-starts-on"
              nbInput
              fullWidth
              type="date"
              formControlName="starts_on"
              [status]="showInputError('starts_on') ? 'danger' : 'basic'"
            />
          </div>

          <label class="label" for="contract-ends-on">{{ "dialogs.contract.fields.ends_on" | translate }}</label>
          <div class="field">
            <input id="contract-ends-on" nbInput fullWidth type="date" formControlName="ends_on" />
          </div>

          <label class="label" for="contract-renewal">{{ "dialogs.contract.fields.renewal" | translate }}</label>
          <div class="field">
            <nb-select id="contract-renewal" fullWidth formControlName="renewal">
              @for (r of renewals; track r) {
                <nb-option [value]="r">{{ "dialogs.contract.options.renewal." + r | translate }}</nb-option>
              }
            </nb-select>
          </div>

          <label class="label" for="contract-notice">{{ "dialogs.contract.fields.notice_days" | translate }}</label>
          <div class="field">
            <input
              id="contract-notice"
              nbInput
              fullWidth
              type="number"
              min="0"
              formControlName="notice_days"
              [status]="showInputError('notice_days') ? 'danger' : 'basic'"
            />
          </div>
        </div>
      </section>

      <!-- Konditionen -->
      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.contract.sections.terms" | translate }}</h5>
        </header>
        <div class="grid">
          <label class="label" for="contract-cycle">{{ "dialogs.contract.fields.billing_cycle" | translate }}</label>
          <div class="field">
            <nb-select id="contract-cycle" fullWidth formControlName="billing_cycle">
              @for (c of cycles; track c) {
                <nb-option [value]="c">{{ "dialogs.contract.options.cycle." + c | translate }}</nb-option>
              }
            </nb-select>
          </div>

          <label class="label" for="contract-fee">{{ "dialogs.contract.fields.base_fee" | translate }}</label>
          <div class="field">
            <input
              id="contract-fee"
              nbInput
              fullWidth
              type="number"
              min="0"
              step="0.01"
              formControlName="base_fee_eur"
              [status]="showInputError('base_fee_eur') ? 'danger' : 'basic'"
            />
            <p class="hint">{{ "dialogs.contract.hints.base_fee" | translate }}</p>
          </div>

          <label class="label" for="contract-terms">{{ "dialogs.contract.fields.payment_terms_days" | translate }}</label>
          <div class="field">
            <input
              id="contract-terms"
              nbInput
              fullWidth
              type="number"
              min="0"
              max="180"
              formControlName="payment_terms_days"
              [status]="showInputError('payment_terms_days') ? 'danger' : 'basic'"
            />
          </div>

          <label class="label" for="contract-invoice-mode">{{ "dialogs.contract.fields.invoice_mode" | translate }}</label>
          <div class="field">
            <nb-select id="contract-invoice-mode" fullWidth formControlName="invoice_mode">
              @for (m of invoiceModes; track m) {
                <nb-option [value]="m">{{ "dialogs.contract.options.invoiceMode." + m | translate }}</nb-option>
              }
            </nb-select>
          </div>

          <label class="label" for="contract-billing-start">{{ "dialogs.contract.fields.billing_starts_on" | translate }}</label>
          <div class="field">
            <input id="contract-billing-start" nbInput fullWidth type="date" formControlName="billing_starts_on" />
            <p class="hint">{{ "dialogs.contract.hints.billing_starts_on" | translate }}</p>
          </div>

          <label class="label" for="contract-invoice-email">{{ "dialogs.contract.fields.invoice_email" | translate }}</label>
          <div class="field">
            <input
              id="contract-invoice-email"
              nbInput
              fullWidth
              type="email"
              formControlName="invoice_email"
              [status]="showInputError('invoice_email') ? 'danger' : 'basic'"
            />
          </div>

          <label class="label" for="contract-buyer-reference">{{ "dialogs.contract.fields.buyer_reference" | translate }}</label>
          <div class="field">
            <input
              id="contract-buyer-reference"
              nbInput
              fullWidth
              formControlName="buyer_reference"
              [status]="showInputError('buyer_reference') ? 'danger' : 'basic'"
            />
            <p class="hint">{{ "dialogs.contract.hints.buyer_reference" | translate }}</p>
          </div>

          <label class="label" for="contract-po">{{ "dialogs.contract.fields.po_number" | translate }}</label>
          <div class="field">
            <input
              id="contract-po"
              nbInput
              fullWidth
              formControlName="po_number"
              [status]="showInputError('po_number') ? 'danger' : 'basic'"
            />
          </div>

          <label class="label" for="contract-note">{{ "dialogs.contract.fields.note" | translate }}</label>
          <div class="field">
            <textarea
              id="contract-note"
              nbInput
              fullWidth
              rows="2"
              formControlName="note"
              [status]="showInputError('note') ? 'danger' : 'basic'"
            ></textarea>
            <p class="hint">{{ "dialogs.contract.hints.note" | translate }}</p>
          </div>
        </div>

        <div class="usage" formGroupName="usage">
          <nb-checkbox formControlName="enabled">{{ "dialogs.contract.usage.enabled" | translate }}</nb-checkbox>
          @if (usageEnabled) {
            <div class="usage-grid">
              <div class="field">
                <label class="label" for="contract-usage-included">{{ "dialogs.contract.usage.included" | translate }}</label>
                <input
                  id="contract-usage-included"
                  nbInput
                  type="number"
                  min="0"
                  formControlName="included_per_period"
                />
              </div>
              <div class="field">
                <label class="label" for="contract-usage-unit">{{ "dialogs.contract.usage.unitSize" | translate }}</label>
                <input id="contract-usage-unit" nbInput type="number" min="1" formControlName="unit_size" />
              </div>
              <div class="field">
                <label class="label" for="contract-usage-price">{{ "dialogs.contract.usage.unitPrice" | translate }}</label>
                <input
                  id="contract-usage-price"
                  nbInput
                  type="number"
                  min="0"
                  step="0.01"
                  formControlName="unit_price_eur"
                  [status]="showInputError(['usage', 'unit_price_eur']) ? 'danger' : 'basic'"
                />
              </div>
            </div>
          }
          <p class="hint">{{ "dialogs.contract.usage.hint" | translate }}</p>
        </div>
      </section>

      <!-- Kontingente -->
      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.contract.sections.limits" | translate }}</h5>
          <p class="hint">{{ "dialogs.contract.limits.hint" | translate }}</p>
        </header>
        <div class="limits" formGroupName="limits">
          <span class="limits__head">{{ "dialogs.contract.limits.area" | translate }}</span>
          <span class="limits__head">{{ "dialogs.contract.limits.template" | translate }}</span>
          <span class="limits__head">{{ "dialogs.contract.limits.contract" | translate }}</span>

          @for (key of limitKeys; track key) {
            <span class="limits__area">{{ "dialogs.contract.limits." + key | translate }}</span>
            <span class="limits__ref">{{ formatLimit(key, referenceLimits[key]) }}</span>
            <div class="limits__edit" [formGroupName]="key">
              <input
                nbInput
                size="small"
                type="number"
                min="0"
                formControlName="value"
                [attr.aria-label]="'dialogs.contract.limits.' + key | translate"
                [status]="showInputError(['limits', key, 'value']) ? 'danger' : 'basic'"
              />
              @if (canBeUnlimited(key)) {
                <nb-checkbox formControlName="unlimited">{{ "dialogs.contract.limits.unlimited" | translate }}</nb-checkbox>
              }
            </div>
          }
        </div>
      </section>

      <!-- Funktionen -->
      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.contract.sections.features" | translate }}</h5>
          <p class="hint">{{ "dialogs.contract.hints.features" | translate }}</p>
        </header>
        <div class="features" formGroupName="features">
          @for (key of featureKeys; track key) {
            @if (featureGroup.contains(key)) {
              <nb-checkbox [formControlName]="key">{{ featureLabel(key) }}</nb-checkbox>
            }
          }
        </div>
      </section>

      <!-- Abrechnung (Phase 3): erst mit aktivem Vertrag -->
      @if (contract) {
        <section class="tile-flat">
          <header class="tile-flat__header">
            <h5>{{ "dialogs.contract.sections.billing" | translate }}</h5>
          </header>
          <app-contract-invoices
            [clientId]="clientId"
            [payload]="payload"
            (changed)="refreshBilling()"
          ></app-contract-invoices>
        </section>
      }

      <!-- Aenderungsverlauf -->
      @if (auditView.length) {
        <section class="tile-flat">
          <header class="tile-flat__header">
            <h5>{{ "dialogs.contract.sections.history" | translate }}</h5>
          </header>
          <div class="audit">
            @for (entry of auditView; track entry.id) {
              <div class="audit__entry">
                <div class="audit__meta">
                  <strong>{{ "dialogs.contract.audit.actions." + entry.action | translate }}</strong>
                  <span>{{ entry.who }}</span>
                  <span>{{ entry.at | date: "dd.MM.yyyy, HH:mm" }}</span>
                </div>
                @if (entry.rows.length) {
                  <ul class="audit__changes">
                    @for (row of entry.rows; track row.field) {
                      <li>
                        <span class="audit__field">{{ row.label }}</span>
                        <span class="audit__value">{{ row.before }}</span>
                        <span aria-hidden="true">→</span>
                        <span class="audit__value">{{ row.after }}</span>
                      </li>
                    }
                  </ul>
                }
                @if (entry.note) {
                  <p class="audit__note">{{ entry.note }}</p>
                }
              </div>
            }
          </div>
        </section>
      }
    </div>
  }
</div>
